import React from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import { routes } from './routes'
import Helmet from 'react-helmet'
import TopNav from './components/Navigations/TopNav'
import MobileMegaMenu from './components/Navigations/MobileMegaMenu'
import CartDrawer from './components/CartDrawer'
import FavoritesDrawer from './components/FavoritesDrawer'
import HeadacheNav from './components/Navigations/HeadacheNav'
import Footer from './components/Footer'
// Stylesheets
import 'bootstrap/dist/css/bootstrap.min.css'
import './theme.css'
import './stack-interface.css'
import './App.css'

// FontAwesome setup
import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faTimes,
	faLock,
	faCreditCard,
	faUndoAlt,
	faTint,
	faTshirt,
	faShoppingBag,
	faTag,
	faChevronRight,
	faChevronLeft,
	faEnvelope,
	faPhone,
	faHeart,
	faShoppingCart,
	faStar,
	faStarHalfAlt
} from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

library.add(
	fab,
	faTimes,
	faLock,
	faCreditCard,
	faUndoAlt,
	faTint,
	faTshirt,
	faShoppingBag,
	faTag,
	faChevronRight,
	faChevronLeft,
	faEnvelope,
	faPhone,
	faHeart,
	far,
	faShoppingCart,
	faStar,
	faStarHalfAlt
)

class App extends React.Component {
	render() {
		return (
			<div className='App'>
				<Router>
					<Helmet title='The Etho' />
					<TopNav />
					<HeadacheNav />
					<MobileMegaMenu />
					<CartDrawer />
					<FavoritesDrawer />
					{/* <MobileNav routes={routes} /> */}
					{routes.map((route, i) => {
						if (route.hasOwnProperty('component')) {
							return <Route key={i} {...route} />
						} else {
							return route.subroutes.map((subroute, j) => {
								if (subroute.hasOwnProperty('component')) {
									return <Route key={j} {...subroute} />
								} else {
									return subroute.subroutes.map(
										(subroute, k) => {
											return (
												<Route key={k} {...subroute} />
											)
										}
									)
								}
							})
						}
					})}
					<Footer />
				</Router>
			</div>
		)
	}
}

export default App
